import Icon from "@/components/icon";
import { useAudioControls } from "../hooks/use-audio-controls";

interface SkipButtonProps {
  direction: "forward" | "backward";
}

const SkipButton: React.FC<SkipButtonProps> = ({ direction }) => {
  const { skipForward, skipBackward, isAudioReady } = useAudioControls();
  const label = direction === "forward" ? "Skip forward 15s" : "Skip back 15s";
  const handler = direction === "forward" ? skipForward : skipBackward;

  return (
    <button
      onClick={handler}
      disabled={!isAudioReady}
      className="p-2 rounded-full bg-default-700"
      title={label}
    >
      <Icon name={direction === "forward" ? "rotate-right" : "rotate-left"} className="w-4 h-4 text-background" aria-hidden />
    </button>
  );
};

export default SkipButton;
